export default __webpack_public_path__ + "static/media/3.7194b7d9.png";